/**
 * ScrollToTop Component
 * 
 * A subtle, floating button that appears when user scrolls down.
 * Clicking it smoothly scrolls back to the top of the page.
 * Uses the dark theme color palette with gold accent.
 */

import { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";
import { colors } from "../styles/colors";

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Show button when user scrolls down 400px
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      data-testid="scroll-to-top"
      className="fixed bottom-24 right-8 p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-40"
      style={{
        backgroundColor: colors.backgroundLight,
        border: `1px solid ${colors.border}`,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = colors.accent;
        e.currentTarget.style.borderColor = colors.accent;
        e.currentTarget.querySelector('svg').style.color = colors.background;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = colors.backgroundLight;
        e.currentTarget.style.borderColor = colors.border;
        e.currentTarget.querySelector('svg').style.color = colors.accent;
      }}
      aria-label="Scroll to top"
    >
      <ChevronUp 
        className="w-5 h-5" 
        style={{ color: colors.accent }}
      />
    </button>
  );
}
